import BaseApi from "./BaseApi";

export default class ScannerService extends BaseApi {


    constructor(){
        super();
    }
 
    /**
     * INDEX
     * Get assets
     */
    async index()
    {
        return this.http.get(`${this.baseUrl}/fingerprint-scanners`)
        .catch(this.handleErrorResponse);
    }

    /**
     * STORE
     * Store asset
     * @param {*} data 
     */
    async store(data)
    {
        return this.http.post(`${this.baseUrl}/fingerprint-scanners`, data)
        .catch(this.handleErrorResponse);
    }

    /**
     * GET
     * Get one asset
     * @param {string} id asset id
     */
    async get(id)
    {
        return this.http.get(`${this.baseUrl}/fingerprint-scanners/${id}`)
        .catch(this.handleErrorResponse);
    }

  

    /**
     * UPDATE
     * update asset
     * @param {string} id asset's id
     * @param {*} data  
     */
    async update(id, data)
    {
        return this.http.put(`${this.baseUrl}/fingerprint-scanners/${id}`, data)
        .catch(this.handleErrorResponse);
    }

   
    /**
     * DELETE
     * Delete asset
     * @param {string} id asset's id
     */
    async delete(id)
    {
        return this.http.delete(`${this.baseUrl}/fingerprint-scanners/${id}`)
        .catch(this.handleErrorResponse);
    }



}